<div class="image-container">
  <img src="{{ mainImageURL }}" data-cy="product-detail-seller-image" />
  <ion-icon
    name="restaurant"
    class="no-image"
    *ngIf="!mainImageURL"
    data-cy="product-detail-seller-image-icon"
  ></ion-icon>
</div>
